import { render } from "./PreCuCal.vue?vue&type=template&id=34b3ee3c&scoped=true"
import script from "./PreCuCal.vue?vue&type=script&lang=js"
export * from "./PreCuCal.vue?vue&type=script&lang=js"

import "./PreCuCal.vue?vue&type=style&index=0&id=34b3ee3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34b3ee3c"

export default script